import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(() => createStyles({
  loadingPageRoot: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center'
  }
}));